module.exports = __webpack_public_path__ + "img/laptop_email.1e350583.jpg";